import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Card from '../components/UI/Card'
import WalletFixasList from './wallet/WalletFixasList';
import WalletAcoesList from './wallet/WalletAcoesList';
import WalletFIIsList from './wallet/WalletFIIsList';
import WalletStocksList from './wallet/WalletStocksList';
import WalletEtfsList from './wallet/WalletEtfsList';
import WalletReitsList from './wallet/WalletReitsList';

import Flag from 'react-world-flags'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChartLine } from "@fortawesome/free-solid-svg-icons";

import Loading from '../components/UI/Loading';
import WalletSummary from './wallet/WalletSummary';

function WalletPage() {
    const dispatch = useDispatch();

    const [key, setKey] = useState('resumo');
    const [isLoading, setIsLoading] = useState(true);

    const [totalFixas, setTotalFixas] = useState(0);
    const [totalAcoes, setTotalAcoes] = useState(0);
    const [totalFiis, setTotalFiis] = useState(0);
    const [totalStocks, setTotalStocks] = useState(0);
    const [totalETFs, settotalETFs] = useState(0);
    const [totalREITs, settotalREITs] = useState(0);

    const resetHandler = () => {
        dispatch({ type: 'reset' });
    };

    const sumHandler = () => {
        dispatch({ type: 'sum', value: [totalFixas, totalAcoes, totalFiis, totalStocks, totalETFs, totalREITs] });
    };

    const updateFixasHandler = async (investido, fixas) => {
        dispatch({ type: 'setTotalInvestidoFixas', value: investido });
        setTotalFixas(fixas);
        dispatch({ type: 'setTotalFixas', value: fixas });
    };

    const updateAcoesHandler = async (investido, acoes) => {
        dispatch({ type: 'setTotalInvestidoAcoes', value: investido });
        setTotalAcoes(acoes);
        dispatch({ type: 'setTotalAcoes', value: acoes });
    };

    const updateFiisHandler = async (investido, fiis) => {
        dispatch({ type: 'setTotalInvestidoFIIs', value: investido });
        setTotalFiis(fiis);
        dispatch({ type: 'setTotalFIIs', value: fiis });
    };

    const updateStocksHandler = async (investido, stocks) => {
        dispatch({ type: 'setTotalInvestidoStocks', value: investido });
        setTotalStocks(stocks);
        dispatch({ type: 'setTotalStocks', value: stocks });
    };

    const updateEtfsHandler = async (investido, etfs) => {
        dispatch({ type: 'setTotalInvestidoETFs', value: investido });
        settotalETFs(etfs);
        dispatch({ type: 'setTotalETFs', value: etfs });
    };

    const updateReitsHandler = async (investido, reits) => {
        dispatch({ type: 'setTotalInvestidoREITs', value: investido });
        settotalREITs(reits);
        dispatch({ type: 'setTotalREITs', value: reits });
    };

    useEffect(() => {
        resetHandler();
    }, []);

    useEffect(() => {
        setIsLoading(true);
        sumHandler();
        setIsLoading(false);
    }, [totalFixas, totalAcoes, totalFiis, totalStocks, totalETFs, totalREITs, sumHandler]);

    const resumoTitle = <><FontAwesomeIcon icon={faChartLine} /> Resumo</>;
    const rendaFixaTitle = <><Flag code="bra" height="15" /> Renda Fixa</>;
    const acoesTitle = <><Flag code="bra" height="15" /> Ações</>;
    const fiisTitle = <><Flag code="bra" height="15" /> FIIs&nbsp;</>;
    const stocksTitle = <><Flag code="usa" height="13" /> Stocks</>;
    const etfsTitle = <><Flag code="usa" height="13" /> ETFs</>;
    const reitsTitle = <><Flag code="usa" height="13" /> REITs</>;

    return <>
        {isLoading && <Loading />}
        {!isLoading && <>
            <div className="row mainPanel">
                <div className="col col-md-12">
                    <Card className="mainCard">
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => setKey(k)}
                            className="mb-3"
                        >
                            <Tab eventKey="resumo" title={resumoTitle}>
                                <WalletSummary />
                            </Tab>
                            <Tab eventKey="rendafixa" title={rendaFixaTitle}>
                                <WalletFixasList onUpdateAssets={updateFixasHandler} isLoading={isLoading} setIsLoading={setIsLoading} />
                            </Tab>
                            <Tab eventKey="acoes" title={acoesTitle}>
                                <WalletAcoesList onUpdateAssets={updateAcoesHandler} isLoading={isLoading} setIsLoading={setIsLoading} />
                            </Tab>
                            <Tab eventKey="fiis" title={fiisTitle}>
                                <WalletFIIsList onUpdateAssets={updateFiisHandler} isLoading={isLoading} setIsLoading={setIsLoading} />
                            </Tab>
                            <Tab eventKey="stocks" title={stocksTitle}>
                                <WalletStocksList onUpdateAssets={updateStocksHandler} isLoading={isLoading} setIsLoading={setIsLoading} />
                            </Tab>
                            <Tab eventKey="etfs" title={etfsTitle}>
                                <WalletEtfsList onUpdateAssets={updateEtfsHandler} isLoading={isLoading} setIsLoading={setIsLoading} />
                            </Tab>
                            <Tab eventKey="reits" title={reitsTitle}>
                                <WalletReitsList onUpdateAssets={updateReitsHandler} isLoading={isLoading} setIsLoading={setIsLoading} />
                            </Tab>
                            {/* <Tab eventKey="contact" title="Contact" disabled>
                                Em breve.
                            </Tab> */}
                        </Tabs>
                    </Card>
                </div>
            </div>
            <div className="row adPanel">
                <div className='col'>sdafads<br />sdafads<br />sdafads<br /></div>
            </div>
        </>}
    </>

}

export default WalletPage;